export default {
  title: 'Tekoälyn ehdotukset',
  subtitle: 'FoodAmigos-agentin ehdotukset ravintoloillesi.',
  empty: 'Ei näytettävää.',
  tabs: {
    pending: 'Odottaa',
    history: 'Historia',
  },
  table: {
    id: 'Tunnus',
    company: 'Ravintola',
    type: 'Tyyppi',
    summary: 'Ehdotus',
    created_at: 'Luotu',
    status: 'Tila',
    actions: 'Toiminnot',
  },
  statuses: {
    pending: 'Odottaa',
    confirmed: 'Vahvistettu',
    applied: 'Toteutettu',
    rejected: 'Hylätty',
    failed: 'Epäonnistui',
    expired: 'Vanhentunut',
  },
  types: {
    'smart_pricing.global_reduce': 'Koko ruokalistan alennus',
    'smart_pricing.category_reduce': 'Kategorian alennus',
    'competitor_listing.confirm': 'Vahvista markkinapaikkalistaus',
    'catalog.price_correct': 'Hinnan korjaus',
    'catalog.add_item': 'Lisää puuttuva tuote',
    'catalog.quality': 'Sisällön laatu',
    'catalog.reorder': 'Ruokalistan järjestäminen uudelleen',
  },
  actions: {
    review: 'Tarkista',
    confirm: 'Vahvista',
    reject: 'Hylkää',
    cancel: 'Peruuta',
    edit: 'Muokkaa',
  },
  edit: {
    label: 'Kuvaile haluamasi muutos (uusi versio luodaan)',
    placeholder: 'Kuvaile haluamasi muutos',
    placeholders: {
      'smart_pricing.global_reduce':
        'esim. muuta se 15 %:ksi, nimeä se uudelleen ”Kesä -15 %” tai käytä sitä vain toimituksissa',
      'smart_pricing.category_reduce': 'esim. aseta Juomat-alennukseksi 10 % ja poista nouto',
      'catalog.price_correct': 'esim. poista ”Cola”-korjaus tai aseta ”Pizza” hintaan 7,50 €',
      'catalog.add_item': 'esim. poista ”Vesi”-tuote tai hinnoittele ”Falafel Wrap” hintaan 6,50 €',
      'catalog.quality': 'esim. poista ”Ranskalaiset” ja ”Cola” listalta',
      'catalog.reorder': 'esim. siirrä Juomat viimeiseksi ja myydyin tuote Bowls-kategorian alkuun',
      'competitor_listing.confirm': 'esim. korvaa Uber Eats -linkki osoitteella https://… tai lisää Wolt: https://…',
    },
    submit: 'Luo versio',
  },
  revisions: {
    label: 'Versio',
    original: 'Alkuperäinen',
    revision_n: 'Versio {{n}}',
  },
  detail: {
    title: 'Ehdotuksen tiedot',
    targets: 'Vaikutuksen alaiset tuotteet',
    evidence: 'Miksi agentti ehdottaa tätä',
    no_targets: 'Ei tuotetietoja saatavilla.',
    composed_from: 'Koostuu',
    items_suffix: 'tuotetta',
    nutrition: 'Ravintosisältö',
    uncategorized: 'Luokittelematon',
    decided_by: 'Päätöksen teki',
    decision_note: 'Huomautus',
    category_existing: 'olemassa oleva',
    category_new: 'uusi',
    product: 'Tuote',
    price_change: 'Hinnan muutos',
    no_items: 'Ei tuotteita',
    fills_image: '+ kuva',
    fills_description: '+ kuvaus',
    fills_nutrition: '+ ravintosisältö',
    fills_modifiers: '+ lisukkeet',
    competitor_links: 'Kilpailijoiden linkit',
    no_competitor_links: 'Kilpailijoiden linkkejä ei ole vielä ratkaistu.',
  },
  competitors: {
    lieferando: 'Lieferando',
    wolt: 'Wolt',
    deliveroo: 'Deliveroo',
    uber_eats: 'Uber Eats',
  },
  reject_modal: {
    title: 'Hylkää tämä ehdotus',
    note_label: 'Syy',
    note_placeholder: 'Selitä lyhyesti, miksi hylkäät tämän ehdotuksen',
  },
  toasts: {
    load_failed: 'Ehdotusten lataaminen epäonnistui',
    confirmed: 'Ehdotus vahvistettu',
    rejected: 'Ehdotus hylätty',
    action_failed: 'Toimintoa ei voitu suorittaa',
    revision_created: 'Uusi versio luotu',
    revision_failed: 'Versiota ei voitu luoda tästä ohjeesta',
    choose_revision: 'Tällä ehdotuksella on useita versioita — avaa se ja valitse vahvistettava versio',
  },
};
